import { ComponentState } from "../types/componentState.enum"
import { InputInterface } from "../types/input.interface"
import { Component } from "./component"

export class Input extends Component<InputInterface> {
    elements: NodeListOf<HTMLInputElement> | undefined

    override createComponent() {
        this.elements = document.querySelectorAll(
            this.props.elementID
        ) as NodeListOf<HTMLInputElement>
        if (this.elements.length === 0) {
            this.state = ComponentState.ERROR
        }
    }

    showPlaceholder(showPlaceholder?: boolean) {
        if (showPlaceholder === false) {
            this.elements?.forEach((formField) => {
                const input = formField.querySelector("input")

                input!.placeholder = ""
            })
        }
    }

    private setLabelColor(labelColor?: string): void {
        if (labelColor) {
            this.elements?.forEach((formField) => {
                const label = formField.querySelector("label")
                label!.style.color = labelColor
            })
        }
    }

    private setBorderColor(borderColor?: string) {
        if (borderColor) {
            this.elements?.forEach((formField) => {
                formField?.style.setProperty(
                    "--hc-form-field-border-color",
                    borderColor
                )
            })
        }
    }

    render(): void {
        this.setLabelColor(this.props.labelColor)
        this.setBorderColor(this.props.borderColor)
        this.showPlaceholder(this.props.showPlaceholder)
        super.render()
    }
}
